// extracted by mini-css-extract-plugin
export var cell = "_5e-4";
export var headerCell = "_5e-2";
export var rowHeader = "_5e-3";
export var table = "_5e-1";
export var tableContainer = "_5e-0";